import axios from "@/plugins/axios";

/**
 * Upload an image for TipTap.
 * Uses /storage/upload (works locally via disk when AWS is not configured)
 * instead of presigned S3 PUTs.
 */
export async function uploadRichTextImage(file) {
  if (!file) throw new Error("No file provided");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("name", file.name);

  const { data: uploadData } = await axios.post(`/storage/upload`, formData);
  if (!uploadData?.key) {
    throw new Error("Upload failed: missing storage key");
  }

  const { data: textConfigImagesData, config } = await axios.post(`/text_config_images`, {
    key: uploadData.key,
  });

  if (!textConfigImagesData?.src) {
    throw new Error("Upload failed: missing image src");
  }

  const imageUrl = `${config.baseURL}/${textConfigImagesData.src}`;
  return { src: imageUrl, alt: file.name };
}
